import { render, staticRenderFns } from "./PatentsCrud.vue?vue&type=template&id=55278493"
import script from "./PatentsCrud.vue?vue&type=script&lang=js"
export * from "./PatentsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports